import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { AGENT_CONFIG } from '../agent/config'
import api from '../../api/api'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

export default function ViewDiscountSale() {
    const navigate = useNavigate();

    const [CustomerTypes, setCustomerTypes] = useState([])
    const [CustomerTypeNo, setCustomerTypeNo] = useState('')
    const [DiscountMinimum_1, setDiscountMinimum_1] = useState('')
    const [DiscountMinimum_2, setDiscountMinimum_2] = useState('')
    const [DiscountPercent_1, setDiscountPercent_1] = useState('')
    const [DiscountPercent_2, setDiscountPercent_2] = useState('')

    async function getCustomerTypes() {

        // let _params = new HttpParams();

        // if (CustomerName) {
        //     _params = _params.append('name', CustomerName);
        // }


        const res = await api.get(AGENT_CONFIG.requests.getCustomerTypes.url)
        const data = res.data
        if (data.status === true) {
            setCustomerTypes(data.result.length > 0 ? data.result.filter(x => x.CustomerTypeNo !== 'CT00') : [])
        }
    }
    useEffect(() => {
        getCustomerTypes()
    }, [])

    const handleSubmit = async () => {

        const body = {
            DiscountMinimum_1: DiscountMinimum_1 || 0,
            DiscountMinimum_2: DiscountMinimum_2 || 0,
            DiscountPercent_1: DiscountPercent_1 || 0,
            DiscountPercent_2: DiscountPercent_2 || 0,
        }
        async function editDiscountSale() {

            const url = AGENT_CONFIG.requests.getCustomerTypes.url + `/${CustomerTypeNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
            }else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }

        }
        editDiscountSale()
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid">
                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-12 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                ส่วนลดการขาย
                            </label>


                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-4 col-md-12">
                            <label class="labelInput">ประเภทลูกค้า</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={CustomerTypeNo} onChange={e => {
                                        setCustomerTypeNo(e.target.value)
                                        const data = CustomerTypes?.find((y) => y?.CustomerTypeNo === e.target.value)
                                        setDiscountMinimum_1(data?.DiscountMinimum_1)
                                        setDiscountMinimum_2(data?.DiscountMinimum_2)
                                        setDiscountPercent_1(data?.DiscountPercent_1)
                                        setDiscountPercent_2(data?.DiscountPercent_2)
                                    }} disableUnderline >
                                        {CustomerTypes?.map((x) => (
                                            <MenuItem value={x?.CustomerTypeNo}>{x?.TypeName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>

                        </div>
                    </div>
                    <hr class="chr" />
                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-12 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                เงื่อนไขที่ 1
                            </label>


                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            <label class="labelInput">จำนวนเงินที่ซื้อ</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={DiscountMinimum_1} onChange={e => setDiscountMinimum_1(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-2 col-sm-6">
                            <label class="labelInput">ได้รับส่วนลด (%)</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={DiscountPercent_1} onChange={e => setDiscountPercent_1(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                    <hr class="chr" />
                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-12 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                เงื่อนไขที่ 2
                            </label>


                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            <label class="labelInput">จำนวนเงินที่ซื้อ</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={DiscountMinimum_2} onChange={e => setDiscountMinimum_2(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-2 col-sm-6">
                            <label class="labelInput">ได้รับส่วนลด (%)</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={DiscountPercent_2} onChange={e => setDiscountPercent_2(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                    <hr class="chr" />
                    <div class="col-12 text-left">

                        <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                        <Button variant='contained' onClick={handleSubmit} sx={{ width: '130px', fontSize: '14px' }}>เเก้ไข</Button>
                    </div>
                </div>
            </Page>
        </div>
    )
}
